import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-17f8e6b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-text-center p-mb-0" }
const _hoisted_2 = { class: "p-text-center p-mb-3" }
const _hoisted_3 = { class: "p-inputgroup" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t("forgotPassword.welcome")), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("forgotPassword.title")), 1),
    _createVNode(_component_Card, { style: {"width":"100%","box-shadow":"unset"} }, {
      title: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              style: {"height":"0.5em"}
            }))
          : _createCommentVNode("", true)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_InputText, {
            modelValue: _ctx.form.email.$value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email.$value) = $event)),
            placeholder: _ctx.$t('forgotPassword.placeholder'),
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.email.$validate())),
            class: _normalizeClass({ 'p-invalid': _ctx.form.email.$hasError })
          }, null, 8, ["modelValue", "placeholder", "class"])
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          "icon-pos": "right",
          icon: "pi pi-send",
          label: _ctx.$t('forgotPassword.continue'),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit())),
          disabled: _ctx.hasError,
          class: "p-button-rounded"
        }, null, 8, ["label", "disabled"])
      ]),
      _: 1
    })
  ], 64))
}